import { RouterLocation } from '~globals/interfaces';

import Layout from './Layout';

type Props = { location: RouterLocation; seo?: WpSeo };

const FullWidth = ({ location, children }: React.PropsWithChildren<Props>) => {
    return <Layout location={location}>{children}</Layout>;
};

export default FullWidth;
